// extracted by mini-css-extract-plugin
export default {"PostCreate":"qf_a bhj_qr bhj_a bhj_w bhj_ea"};